export default async function CreateKpiApi(
  id,
  name,
  target,
  scaleId,
  scaleUnitId
) {
  let res = "";
  try {
    const body = {
      planId: id,
      name: name,
      target: target,
      scaleId: scaleId,
      scaleUnitId: scaleUnitId,
    };
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/kpis/`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
